import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSchedulingNotificationApi, getSchedulingNotificationCountApi } from "../../apis/notificationApi";
import { GetSchedulingNotificationCountPayloadType, GetSchedulingNotificationPayloadType } from "../../commonTypes/notificationType";

export const getSchedulingNotificationAction = createAsyncThunk(
    `notification/scheduling`,
    async (data: GetSchedulingNotificationPayloadType) => {
        const response = await getSchedulingNotificationApi(data);
        return response.data;
    }
);

export const getSchedulingNotificationCountAction = createAsyncThunk(
    `notificationCount/scheduling`,
    async (data: GetSchedulingNotificationCountPayloadType) => {
        const response = await getSchedulingNotificationCountApi(data);
        return response.data;
    }
);